module.exports = __webpack_public_path__ + "static/media/Index-Furniture.2f02d343.png";